export default __webpack_public_path__ + "static/media/atpmail.95565e28.svg";